import { api } from 'utility';
import {
  getLogFeature,
} from 'URLs';

export function getLogFeaturePages(data, config = {}) {
  return api.post(getLogFeature(), data, config).then((res) => res.data);
}
export default {
  getLogFeaturePages,
};